<div class="d-flex justify-content-between align-items-center mb-4">
  <div class="h4 m-0" [ngStyle]="{direction: 'ltr'}">
    {{firstName + ' ' + lastName}} {{translate.currentLang == 'en' ? 'Profile' : 'الملف الشخصي'}}
  </div>
  <button mat-button  class="h5" routerLink="edit-profile">
    <img
    src="../../../../assets/icons/setting-icon.svg"
    width="30"
    />
    {{translate.currentLang == 'en' ? 'Edit Profile' : 'تعديل الملف الشخصي'}}
  </button>
</div>

<div class="row justify-content-start gap-2">
  <div class="input-style col-12 col-md-5">
    <p>
      {{translate.currentLang == 'en' ? 'First Name' : 'الاسم الاول'}}
    </p>
    <p>{{firstName}}</p>
  </div>

  <div class="input-style col-12 col-md-5">
    <p>
      {{translate.currentLang == 'en' ? 'Last Name' : 'الاسم الثاني'}}
    </p>
    <p>{{lastName}}</p>
  </div>

  <div class="input-style col-10" >
    <p>
      {{translate.currentLang == 'en' ? 'Phone Number' : 'رقم الهاتف'}}
    </p>
    <p>{{phoneNumber}}</p>
  </div>

  <div class="input-style col-10">
    <p>
      {{ translate.currentLang == 'en' ? 'Email' : 'البريد الالكتروني'}}
    </p>
    <p>{{email}}</p>
  </div>
</div>
